/**
 * Brand tokens for the secondary CRM theme.
 *
 * Lives in the host app (not in jopi): the design-system library only ships
 * Tokko Broker and accepts a brand object at runtime. Keep this file private.
 *
 * `name` must match the value written to <html data-theme> by SettingsReactLoader.
 */

/** Resolves per data-theme via designTokens (`--color-brand-badges-background`). */
export const JOPI_BADGE_ON_BRAND_COLORS = {
  badgeOnBrand: 'var(--color-brand-badges-background)',
  badgeOnBrandText: '#FFFFFF',
};

/** Shared jopi Badge variant for header/sidebar counters on brand surfaces. */
export const BADGE_ON_BRAND_VARIANT = ['badgeNormal', 'onBrand'];

const JOPI_UNIVEN_BRAND = {
  name: 'univen',
  colors: {
    primary: '#0046D2',
    primaryHover: '#0038A8',
    primaryPressed: '#002A7E',
    primaryAccent: '#CCDAF6',
    secondary: '#062756',
    secondaryHover: '#2A4A77',
    secondaryPressed: '#4F6D98',
    petrokoPressed: '#2A4A77',
    petrokoHeader: '#062756',
    ...JOPI_BADGE_ON_BRAND_COLORS,
  },
  fontFamily: '"Oatmeal Pro", "Nunito Sans", sans-serif',
};

export default JOPI_UNIVEN_BRAND;
